// extracted by mini-css-extract-plugin
var _1 = "styles-module__container___K40MR";
var _2 = "styles-module__image___jjzkn";
var _3 = "styles-module__title___Up1P9";
export { _1 as "container", _2 as "image", _3 as "title" }
